import { DIRHAM_PATH, DIRHAM_VIEWBOX } from './icons.gen';

/**
 * Money formatting, as in the prototypes: Western digits in both languages,
 * thousands separators, two decimals. The dirham symbol sits to the LEFT of
 * the number (CBUAE rule), so the amount is always laid out left to right.
 */
export function formatAmount(n: number, opts: { decimals?: 0 | 2 } = {}): string {
  const d = opts.decimals ?? 2;
  const v = Number.isFinite(n) ? n : 0;
  const s = Math.abs(v).toLocaleString('en-US', { minimumFractionDigits: d, maximumFractionDigits: d });
  // a minus sign (U+2212) reads better than a hyphen in amounts; keep -0.00 as 0.00
  return (v < 0 && s.replace(/[0.,]/g, '') !== '' ? '−' : '') + s;
}

/** Plain text for data, exports, inputs and emails: "AED 1,250.00" (no symbol). */
export const amountCode = (n: number, cur = 'AED'): string => `${cur} ${formatAmount(n)}`;

/** The symbol as an SVG string, for places outside React (PDFs, emails as HTML). */
export const dirhamSvg = (cls = 'dh-s'): string =>
  `<svg class="${cls}" viewBox="${DIRHAM_VIEWBOX}" aria-hidden="true" focusable="false"><path d="${DIRHAM_PATH}"/></svg>`;
